import DafIcon from '@/assets/manufacturers/daf.svg?react'
import FordIcon from '@/assets/manufacturers/ford.svg?react'
import IvecoIcon from '@/assets/manufacturers/iveco.svg?react'
import ManIcon from '@/assets/manufacturers/man.svg?react'
import MercedesIcon from '@/assets/manufacturers/mercedes.svg?react'
import RenaultIcon from '@/assets/manufacturers/renault.svg?react'
import ScaniaIcon from '@/assets/manufacturers/scania.svg?react'
import VolvoIcon from '@/assets/manufacturers/volvo.svg?react'

type Manufacturer = {
  name: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
}
const manufacturers: Array<Manufacturer> = [
  {
    name: 'Volvo',
    icon: VolvoIcon,
  },
  {
    name: 'Mercedes-Benz',
    icon: MercedesIcon,
  },
  {
    name: 'Scania',
    icon: ScaniaIcon,
  },
  {
    name: 'MAN',
    icon: ManIcon,
  },
  {
    name: 'DAF',
    icon: DafIcon,
  },
  {
    name: 'Iveco',
    icon: IvecoIcon,
  },
  {
    name: 'Ford',
    icon: FordIcon,
  },
  {
    name: 'Renault Trucks',
    icon: RenaultIcon,
  },
]

export function useTrucksManufacturers() {
  return manufacturers
}

export function getManufacturerIcon(manufacturerName: string) {
  const manufacturer = manufacturers.find((m) => m.name === manufacturerName)
  return manufacturer?.icon || null
}
